import { STORE_NOTICE_AGREEMENT } from "actions"

export const initialState = {
  telephoneNoticeAgree: "0",
  dmNoticeAgree: "0",
}

export const NoticeAgreement = (state = initialState, action) => {
  switch (action.type) {
    case STORE_NOTICE_AGREEMENT:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default NoticeAgreement
